import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PushToggle } from "@/components/common/PushToggle";
import { Home, CalendarPlus, CalendarClock, Award, User, Sun, Moon, LogOut, Sparkles, Bell } from "lucide-react";

const TABS = [
  { to: "/portale", label: "Home", icon: Home, end: true },
  { to: "/portale/prenota", label: "Prenota", icon: CalendarPlus },
  { to: "/portale/appuntamenti", label: "Appunt.", icon: CalendarClock },
  { to: "/portale/trasformazioni", label: "Foto", icon: Sparkles },
  { to: "/portale/rewards", label: "Rewards", icon: Award },
  { to: "/portale/profilo", label: "Profilo", icon: User },
];

export function PortalLayout({ children }) {
  const { user, logout, theme, setTheme } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let active = true;
    api.get("/portal/notifications")
      .then((r) => { if (active) setUnread(r.data?.unread || 0); })
      .catch(() => {});
    return () => { active = false; };
  }, [location.pathname]);

  return (
    <div className="min-h-screen hi-app-bg">
      <header className="sticky top-0 z-20 h-16 flex items-center justify-between px-4 bg-background/85 backdrop-blur border-b border-border">
        <button onClick={() => navigate("/portale")} className="flex items-center gap-2.5">
          <div className="hi-plaque rounded-lg overflow-hidden" style={{ width: 38, height: 38, padding: 2 }}><img src="/logo.jpg" alt="Hair Identity" className="w-full h-full object-contain" /></div>
          <div className="leading-tight text-left"><div className="font-brand text-lg font-semibold">Hair Identity</div><div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Area Cliente</div></div>
        </button>
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="icon" className="relative" onClick={() => navigate("/portale/notifiche")} data-testid="portal-notifications-bell" aria-label="Notifiche">
            <Bell className="h-5 w-5" />
            {unread > 0 && <span data-testid="portal-unread-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[hsl(var(--hi-gold))] text-white text-[10px] font-semibold flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>}
          </Button>
          <PushToggle />
          <Button variant="ghost" size="icon" onClick={() => setTheme(theme === "dark" ? "light" : "dark")} data-testid="portal-theme-toggle">{theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}</Button>
          <Button variant="ghost" size="icon" onClick={logout} data-testid="portal-logout"><LogOut className="h-5 w-5" /></Button>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-5 pb-28">{children}</main>

      <nav className="fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur border-t border-border">
        <div className="max-w-2xl mx-auto grid grid-cols-6">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink key={t.to} to={t.to} end={t.end} data-testid={`portal-nav-${t.label.toLowerCase()}`}
                className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium ${isActive ? "text-[hsl(var(--hi-gold))]" : "text-muted-foreground"}`}>
                <Icon className="h-5 w-5" />{t.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
